import { render, staticRenderFns } from "./Magazine.vue?vue&type=template&id=6f657f85&scoped=true&"
import script from "./Magazine.vue?vue&type=script&lang=js&"
export * from "./Magazine.vue?vue&type=script&lang=js&"
import style0 from "./Magazine.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Magazine.vue?vue&type=style&index=1&lang=less&"
import style2 from "./Magazine.vue?vue&type=style&index=2&id=6f657f85&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f657f85",
  null
  
)

export default component.exports